import { createFileRoute } from '@tanstack/react-router';

import { HiringJobPage } from '@/features/hiring/job-page';

export const Route = createFileRoute('/_app/projects/$projectId/hiring/jobs/$jobId')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId, jobId } = Route.useParams();
  return <HiringJobPage projectId={projectId} jobId={jobId} />;
}
